var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecruiting = function SvgRecruiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.502 41.283c-10.357 0-18.783-8.426-18.783-18.783 0-10.357 8.426-18.783 18.783-18.783 10.357 0 18.783 8.426 18.783 18.783 0 10.357-8.426 18.783-18.783 18.783Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Recruiting_svg__a)",
    d: "M22.501 33.725c-6.189 0-11.224-5.035-11.224-11.224s5.035-11.224 11.224-11.224 11.224 5.035 11.224 11.224S28.69 33.725 22.5 33.725"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m27 33-3 .5h-2l-1.5-.5c-.5-.333-2.1-.5-2.5-.5-.4 0-.667-.833-1-1l-1.5-.5.5-1v-1.5c0-.5.5-1 .5-1.5 0-.4.667-.833 1-1 1-.5 3.1-1.5 3.5-1.5.4 0 1.5-.333 2-.5l1.5.5c1 .333 3.1 1.1 3.5 1.5l1.5 1.5V31L28 32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.501 33.725c-6.189 0-11.224-5.035-11.224-11.224s5.035-11.224 11.224-11.224 11.224 5.035 11.224 11.224S28.69 33.725 22.5 33.725ZM22.5 7.404V0M22.5 45v-7.05M37.598 22.5h7.404M0 22.5h7.05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M25.57 19.66v.703a3.069 3.069 0 0 1-6.136 0v-.703a3.068 3.068 0 1 1 6.137 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.36 31.152v-2.54c0-1.418.866-2.692 2.185-3.213l4.956-1.958"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m22.5 23.441 4.956 1.958a3.456 3.456 0 0 1 2.186 3.214v2.54"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Recruiting_svg__a",
    x1: 14.5,
    x2: 30.5,
    y1: 11.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgRecruiting;